<template>
  <div class="fp-block">
    <div class="polaroid" :class="leftOrRight">
      <img class="polaroidImage" :src="img.src"/>
      <p class="polaroidText">{{img.text}}</p>
    </div>
    <div class="textBlock" :class="textLeftOrRight">
      <slot>
        <p>Fyll inn tekst her.</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    left: {
      type: Boolean,
      default: false,
    },
    img: {
      type: Object,
      default: {
        src: require('@/assets/cat.jpg'), 
        text: 'Denne katten og teksten skal ikke være her, gi meg et bilde og tekst!'
      },
    },
  },
  data () {
    return {

    }
  },
  computed: {
    leftOrRight() {
      return this.left ? 'left' : 'right'
    },
    textLeftOrRight() {
      return this.left ? 'textLeft' : 'textRight'
    }
  },
  methods: {
    
  }  
}
</script>

<style lang="scss">
  .fp-block {
    display: inline-block;
    margin: 10px 0px;
    color: white; 
    font-family: 'Courier New', Courier, monospace;
    max-width: 100%;
  }

  .polaroid{
    z-index: 2;
    background-color: rgb(255, 255, 255);
    position: relative;
    padding: 2% 2%;
    width: 40%;
    float: left;
    @media screen and (max-width: 900px){
      position: initial;
      width: calc(76%);
      margin: 0 10%;
      float: none;
    }
  }
  .left{
    float: left;
    left: -10%;
    @media screen and (max-width: 900px){
      float: none;
    }
  }
  .right{
    float: right;
    right: -10%;
    @media screen and (max-width: 900px){
      float: none;
    }
  }
  .polaroidImage{
    height: auto;
    width: 100%;
  }
  .polaroidText{
    color: rgb(51, 51, 51);
    padding: 6px 2px 0px;
    font-size: calc(0.6em + 0.75vw);
    font-family: "Shadows Into Light";
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 135%;
    @media screen and (max-width: 900px){
      font-size: calc(1em + 1vw);
    }
  }
  .textBlock{
    position: relative;
    // margin: 2%;
    padding-top: 3vw;
    height: 100%;
    width: 52%;
    display: inline-block;
    @media screen and (max-width: 900px){
      width: 90vw;
      position: initial;
      float: none;
      margin: 5vw;
    }
  }
  .textLeft{
    float: left;
    left: -3%;
  }
  .textRight{
    float: right;
    right: -3%;
  }
</style>
